.featuredContainer {
  padding-left: var(--page-margin);
  padding-right: var(--page-margin);
}

@media all and (--reefer-media-tablet-min) {
  .featuredContainer {
    padding-left: var(--page-margin-desktop);
    padding-right: var(--page-margin-desktop);
  }
}
